import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
// import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import apiClient from "../../axiosInstance";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
      userPermissionCodes: [],
      isAdmin: false,
    };
  }
  componentDidMount() {
    this.loadPermissions();
    this.initMenu();
  }

  loadPermissions = async () => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
      const roleName = String(authUser?.user?.role || "")
        .trim()
        .toLowerCase();

      if (roleName === "admin") {
        this.setState(
          {
            isAdmin: true,
            userPermissionCodes: ["*"],
          },
          () => this.initMenu(),
        );
        return;
      }

      const result = await apiClient.get("/permissions/myPermissions");
      const codes = Array.isArray(result?.data?.response)
        ? result.data.response
        : [];

      this.setState(
        {
          isAdmin: false,
          userPermissionCodes: codes,
        },
        () => this.initMenu(),
      );
    } catch (error) {
      console.error("Failed to load permissions:", error);
      this.setState(
        {
          isAdmin: false,
          userPermissionCodes: [],
        },
        () => this.initMenu(),
      );
    }
  };

  hasPermission = (permissionCode) => {
    if (this.state.isAdmin) {
      return true;
    }

    return this.state.userPermissionCodes.includes(permissionCode);
  };

  hasAnyPermission = (permissionCodes = []) => {
    if (this.state.isAdmin) {
      return true;
    }

    return permissionCodes.some((code) => this.hasPermission(code));
  };

  UNSAFE_componentDidUpdate(prevProps, prevState) {
    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
      this.initMenu();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    if (
      prevState.userPermissionCodes !== this.state.userPermissionCodes ||
      prevState.isAdmin !== this.state.isAdmin
    ) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
    let pathName = window.location.pathname; // Get the current route
    if (pathName === "/") {
      pathName = "/dashboard"; // Default to dashboard if root
    }

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");

    for (let i = 0; i < items.length; ++i) {
      const href = items[i].getAttribute("href");
      if (href === pathName) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }
  handleMenuClick = (e, item) => {
    // Clear all active classes
    const ul = document.getElementById("side-menu");
    const activeItems = ul.querySelectorAll(".active, .mm-active, .mm-show");
    activeItems.forEach((activeItem) => {
      activeItem.classList.remove("active", "mm-active", "mm-show");
    });

    // Check if the item has a child <ul>
    const parentLi = item.closest("li");
    if (!parentLi) {
      return;
    } // If no parent <li>, exit

    const childUl = parentLi.querySelector("ul.sub-menu");
    if (childUl) {
      // If it has a child <ul>, expand it
      parentLi.classList.add("mm-active");
      childUl.classList.add("mm-show");
    } else {
      // If it doesn't have a child <ul>, mark it as active
      item.classList.add("active");
      parentLi.classList.add("mm-active");
    }
  };

  activateParentDropdown = (item) => {
    const ul = document.getElementById("side-menu");
    const activeItems = ul.querySelectorAll(".active, .mm-active, .mm-show");
    activeItems.forEach((activeItem) => {
      activeItem.classList.remove("active", "mm-active", "mm-show");
    });

    // Add active classes to the current item and its parents
    item.classList.add("active");
    let parent = item.parentElement;

    while (parent) {
      // Debugging log
      if (parent.tagName === "LI") {
        parent.classList.add("mm-active");

        // Add mm-show to the child <ul> if it exists
        const childUl = parent.querySelector("ul.sub-menu");
        if (childUl) {
          childUl.classList.add("mm-show");
        }
      }
      parent = parent.parentElement;
    }
  };

  render() {
    const canDashboard = this.hasPermission("dashboard.read");

    const canUsers = this.hasPermission("users.read");
    const canRoles = this.hasPermission("roles.read");
    const canPermissions = this.hasPermission("permissions.read");
    const canRolePermissions = this.hasPermission("roles.update");
    const canChangePassword = this.hasPermission("users.update");
    const showUserManagement = this.hasAnyPermission([
      "users.read",
      "roles.read",
      "permissions.read",
      "roles.update",
      "users.update",
    ]);

    const canBranches = this.hasPermission("branches.read");
    const canOwners = this.hasPermission("owners.read");

    const canExpenseTypes = this.hasPermission("expense_types.read");
    const canExpenses = this.hasPermission("expenses.read");
    const canCashFlow = this.hasPermission("cash_flow_report.read");
    const showExpenses = this.hasAnyPermission([
      "expense_types.read",
      "expenses.read",
      "cash_flow_report.read",
    ]);

    const canVehicleModels = this.hasPermission("vehicle_models.read");
    const canVehicleMakes = this.hasPermission("vehicle_makes.read");
    const canVehicles = this.hasPermission("vehicles.read");
    const canRegistrations = this.hasPermission("vehicle_registrations.read");
    const showVehicles = this.hasAnyPermission([
      "vehicle_models.read",
      "vehicle_makes.read",
      "vehicles.read",
      "vehicle_registrations.read",
    ]);

    const canInspectionItems = this.hasPermission("inspection_items.read");
    const canVehicleInspections = this.hasPermission("vehicle_inspections.read");
    const showInspections = this.hasAnyPermission([
      "inspection_items.read",
      "vehicle_inspections.read",
    ]);

    const canRegistrationFees = this.hasPermission("registration_fees.read");
    const canPaymentMethods = this.hasPermission("payment_methods.read");
    const canPaymentAccounts = this.hasPermission("payment_accounts.read");
    const canCharges = this.hasPermission("charges.read");
    const canPayments = this.hasPermission("payments.read");
    const showFeesPayments = this.hasAnyPermission([
      "registration_fees.read",
      "payment_methods.read",
      "payment_accounts.read",
      "charges.read",
      "payments.read",
    ]);

    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{this.props.t("Menu")}</li>

            {canDashboard && (
              <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="ri-dashboard-line"></i>
                <span className="badge rounded-pill bg-success float-end">
                  3
                </span>
                <span
                  className="ms-1"
                  onClick={(e) => this.handleMenuClick(e, e.target)}
                >
                  {this.props.t("Dashboard")}
                </span>
              </Link>
              </li>
            )}
            {showUserManagement && (
              <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="ri-user-line"></i>
                <span className="ms-1">{this.props.t("User Management")}</span>
              </Link>
              <ul className="sub-menu">
                {canUsers && (
                  <li>
                  <Link
                    to="/users"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Users")}
                  </Link>
                  </li>
                )}
                {canRoles && (
                  <li>
                  <Link
                    to="/roles"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Roles")}
                  </Link>
                  </li>
                )}
                {canPermissions && (
                  <li>
                  <Link
                    to="/permissions"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Permissions")}
                  </Link>
                  </li>
                )}
                {canRolePermissions && (
                  <li>
                  <Link
                    to="/rolePermissions"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Role Permissions")}
                  </Link>
                  </li>
                )}
                {canChangePassword && (
                  <li>
                  <Link
                    to="/changePassword"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Change Password")}
                  </Link>
                  </li>
                )}
              </ul>
              </li>
            )}
            {canBranches && (
              <li>
              <Link to="/branches" className="waves-effect">
                <i className="ri-building-line"></i>
                <span
                  className="ms-1"
                  onClick={(e) => this.handleMenuClick(e, e.target)}
                >
                  {this.props.t("Branches")}
                </span>
              </Link>
              </li>
            )}
            {canOwners && (
              <li>
              <Link to="/owners" className="waves-effect">
                <i className="ri-account-box-line"></i>
                <span
                  className="ms-1"
                  onClick={(e) => this.handleMenuClick(e, e.target)}
                >
                  {this.props.t("Owners")}
                </span>
              </Link>
              </li>
            )}

            {showExpenses && (
              <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="ri-wallet-3-line"></i>
                <span className="ms-1">{this.props.t("Expenses")}</span>
              </Link>
              <ul className="sub-menu">
                {canExpenseTypes && (
                  <li>
                  <Link
                    to="/expenseTypes"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Expense Types")}
                  </Link>
                  </li>
                )}
                {canExpenses && (
                  <li>
                  <Link
                    to="/expenses"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Expenses")}
                  </Link>
                  </li>
                )}
                {canCashFlow && (
                  <li>
                  <Link
                    to="/cashFlowReport"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Cash Flow Report")}
                  </Link>
                  </li>
                )}
              </ul>
              </li>
            )}
            {showVehicles && (
              <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="  ri-car-fill "></i>
                <span className="ms-1">
                  {this.props.t("Vehicles Management")}
                </span>
              </Link>
              <ul className="sub-menu">
                {canVehicleModels && (
                  <li>
                  <Link
                    to="/vehicleModels"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Vehicle Models")}
                  </Link>
                  </li>
                )}
                {canVehicleMakes && (
                  <li>
                  <Link
                    to="/vehicleMakes"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Vehicle Manufacturers")}
                  </Link>
                  </li>
                )}
                {canVehicles && (
                  <li>
                  <Link
                    to="/vehiclesList"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Vehicles")}
                  </Link>
                  </li>
                )}
                {canRegistrations && (
                  <li>
                  <Link
                    to="/registrationsList"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Registrations")}
                  </Link>
                  </li>
                )}
              </ul>
              </li>
            )}
            {showInspections && (
              <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="  ri-tools-fill  "></i>
                <span className="ms-1">{this.props.t("Inspections")}</span>
              </Link>
              <ul className="sub-menu">
                {canInspectionItems && (
                  <li>
                  <Link
                    to="/inspectionItems"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Inspection Items")}
                  </Link>
                  </li>
                )}
                {canVehicleInspections && (
                  <li>
                  <Link
                    to="/vehicleInspections"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Vehicle Inspections")}
                  </Link>
                  </li>
                )}
              </ul>
              </li>
            )}
            {showFeesPayments && (
              <li>
              <Link to="#" className="has-arrow waves-effect">
                <i className="  ri-money-dollar-box-fill "></i>
                <span className="ms-1">{this.props.t("Fees & Payments")}</span>
              </Link>
              <ul className="sub-menu">
                {canRegistrationFees && (
                  <li>
                  <Link
                    to="/registrationFees"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Registration Fees")}
                  </Link>
                  </li>
                )}
                {canPaymentMethods && (
                  <li>
                  <Link
                    to="/paymentMethods"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Payment Methods")}
                  </Link>
                  </li>
                )}
                {canPaymentAccounts && (
                  <li>
                  <Link
                    to="/paymentAccounts"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Payment Accounts")}
                  </Link>
                  </li>
                )}
                {canCharges && (
                  <li>
                  <Link
                    to="/charges"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Charges List")}
                  </Link>
                  </li>
                )}
                {canPayments && (
                  <li>
                  <Link
                    to="/payments"
                    onClick={(e) => this.handleMenuClick(e, e.target)}
                  >
                    {this.props.t("Payments List")}
                  </Link>
                  </li>
                )}
              </ul>
              </li>
            )}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
  })(withTranslation()(SidebarContent)),
);
